export default __webpack_public_path__ + "static/cafe_36008-3c0f64808275b4200b2a9528d69d503b.png";